module.exports = __webpack_public_path__ + "img/register-bg.e76a7204.svg";